<template>
  <div class="tiaokuanCenter clearfix">
    <div class="aa">
      <ui-navigation></ui-navigation>
    </div>
    <div class="aboutBox">
      <div class="info">
        <h3 class="mb-4">
          雪帝交易条款
        </h3>
        <hr class="mb-4">
        <p>
          客户在接受商品订购与送货的同时，有义务遵守以下交易条款。您在雪帝下订单之前或接受雪帝送货之前，请您仔细阅读以下条款：
        </p>
        <p>
          1. 订购的商品价格以您下订单时雪帝网上价格为准。
        </p>
        <p>
          2. 请清楚准确地填写您的真实姓名、送货地址及联系方式。因如下情况造成订单延迟或无法配送等，雪帝将不承担责任：
        </p>
        <p>
          A. 客户提供错误信息和不详细的地址;
        </p>
        <p>
          B. 货物送达无人签收，由此造成的重复配送所产生的费用及相关的后果;
        </p>
        <p>
          C. 不可抗力，例如：自然灾害、交通戒严、突发战争等。
        </p>
        <p>
          3. 安全性：无论您是电话订购商品或是网络订购商品，我们会保证交易信息的安全，并由雪帝授权的员工处理您的订单。
        </p>
        <p>
          4. 隐私权：雪帝尊重您的隐私权，在任何情况下，我们都不会将您的个人和订单信息出售或泄露给任何第三方(国家司法机关调取除外)。我们从网站上或电话中得到的所有客户信息仅用来处理您的相关订单。
        </p>
        <p>
          5. 免责：如因不可抗力或其它雪帝无法控制的原因使雪帝销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，雪帝会尽可能合理地协助处理善后事宜，并努力使客户免受经济损失。
        </p>
        <p>
          6. 客户监督：雪帝希望通过不懈努力，为客户提供最佳服务，雪帝在给客户提供服务的全过程中接受客户的监督。
        </p>
        <p>
          7. 争议处理：如果客户与雪帝之间发生任何争议，可依据当时双方所认定的协议及相关法律进行解决。
        </p>
        <p>
          <br>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import Navigation from '@/components/about/Navigation.vue';

export default {
  name: 'tiaokuanCenter',
  mixins: [generalMix],
  data () {
    return {
    }
  },
  components:{
    'ui-navigation': Navigation
  },
  mounted() {
    $('html').removeClass('scrollHide');
  }
}
</script>

<style scoped lang='less'>
.tiaokuanCenter{
  display: flex;
  div.aa{
    width: 200px;
    margin-right: 30px;
  }
  div.aboutBox{
    flex: 1;
    background-color: #FFFFFF;
    border-radius: 15px;
    padding: 30px;
    h1{
      font-size: 32px;
      color: #FF7B00;
    }
    ul{
      list-style: disc;
      padding-left: 30px;
    }
  }
}
@media (max-width: 992px) {
  .tiaokuanCenter{
    flex-direction: column;
    div.aa{
      margin: 0;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/Tiaokuan.vue